import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssessmentStateService {
  private _isAssessmentActive = new BehaviorSubject<boolean>(false);
  isAssessmentActive$ = this._isAssessmentActive.asObservable();

  setAssessmentActive(active: boolean): void {
    this._isAssessmentActive.next(active);
  }

  get isActive(): boolean {
    return this._isAssessmentActive.getValue();
  }
}